module.exports = __webpack_public_path__ + "static/media/booksell.7e8b0584.png";